import _ from 'lodash';
import { getState } from '~src/state';

export const getSelectedFormatId = () => {
  const formatDefault = getState('selected.formatoDefault');
  const format = getState('selected.formato');

  const isDefaultFormat =
    formatDefault ||
    _.has(format, 'editor_project_formats_default_pointer.objectId');

  let formatId;

  if (isDefaultFormat) {
    formatId =
      formatDefault.objectId ||
      format.editor_project_formats_default_pointer.objectId;
  } else {
    formatId = format.objectId;
  }

  return formatId;
};
